import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dashboard.icon",
  "use": "dashboard.icon-usage",
  "viewBox": "-12058 -16294 28 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-12058 -16294 28 16\" id=\"dashboard.icon\"><defs><style>#dashboard.icon .cls-1{fill:#fff}</style></defs><g id=\"dashboard.icon_Group_394\" data-name=\"Group 394\" transform=\"translate(-12101 -16402)\"><path id=\"dashboard.icon_Subtraction_4\" data-name=\"Subtraction 4\" class=\"cls-1\" d=\"M2,24.518H0a14,14,0,0,1,14-14,13.851,13.851,0,0,1,8.285,2.712L20.753,14.6A11.887,11.887,0,0,0,14,12.516a12.014,12.014,0,0,0-12,12Zm24,0h0a12.019,12.019,0,0,0-2.623-7.482l1.283-1.6A13.981,13.981,0,0,1,28,24.515Z\" transform=\"translate(43 97.484)\" /><circle id=\"dashboard.icon_Ellipse_7\" data-name=\"Ellipse 7\" class=\"cls-1\" cx=\"2\" cy=\"2\" r=\"2\" transform=\"translate(55 120)\" /><path id=\"dashboard.icon_Path_267\" data-name=\"Path 267\" class=\"cls-1\" d=\"M-67.364,226.656l11.4-10.193-9.877,12.282Z\" transform=\"translate(124 -106)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/dashboard.icon.svg
// module id = 2rj0
// module chunks = 13